/*jshint esversion: 6 */
import '../style.css';
import './abruzzo.css';

import storage from '../../../storage.js';
import global from '../../../global.js';
// import * as tools from '../../../tools.js';
import dbmng from '../../../ext/dbmng.js';

// ---- file duplicato da ripulire ----
import * as partecipa from '../../../core/partecipa/partecipa_new.js';
// Se serve GPS
//*********************************************************************
import gps from '../../../core/gps.js';
//*********************************************************************


// TRADUZIONE
//*********************************************************************
import t from '../../../translate.js';
//*********************************************************************

import * as db from '../data.js';
import ae from '../index.js';
var aedita=new ae({style:"f7"});

// Se serve LEAFLET
//*********************************************************************
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
//*********************************************************************


// Variabili globali
//*********************************************************************
global.base_link='https://agroambiente.regione.abruzzo.it/';
global.base_path='https://agroambiente.regione.abruzzo.it/api/';
global.base_call=global.base_path+'userplus/';
global.base_call_aedita=global.base_path;
global.nomeApp='Agro Abruzzo';
global.download_app_path='https://agroambiente.regione.abruzzo.it/app/AgroAmbienteAbruzzo.apk';

global.images_link='https://agroambiente.regione.abruzzo.it/sites/default/files/images/';

global.useSocialLogin=false;
global.language='it';
global.settingsName='agroambiente_abruzzo';
global.nomeRegione='Abruzzo';
global.default_coordinates=[42.3,14];
global.default_zoom=8;

global.app_version='1.0.58'
//*********************************************************************

global.firebaseConfig = {
  apiKey: "AIzaSyAKIbLKalc8AzL63_4KJaA89XfJaF7oNAs",
  authDomain: "agroambiente-abruzzo.firebaseapp.com",
  projectId: "agroambiente-abruzzo",
  storageBucket: "agroambiente-abruzzo.appspot.com",
  messagingSenderId: "344628648210",
  appId: "1:344628648210:web:e3cb33eb2de3a4b659fbcb",
  measurementId: "G-8B4ZRSF00N"
};

if (typeof firebase!=='undefined') {
  global.firebase=firebase.initializeApp(global.firebaseConfig);

  global.messaging = null;

  if (firebase.messaging.isSupported()){
    global.messaging = firebase.messaging();
  }
}


//Hook obbligatorio per definire le route del progetto
export function exe_routes(router){
  router.on({
    'monitoring': function () {
      // cleanPage();
      // location.reload()
      if (jQuery('.left .f7-icons').text()=='chevron_left') {
        location.reload();
      }
      //TODO ???si usa l'uid() aedita.monitoraggio(uid);
      var s=storage.get();
      if (s.user) {
        aedita.monitoraggio();
      }
      else {
        console.log(location.hash);
        location.hash = '#login';
      }
    },
    'view_data': function () {
      if (jQuery('.left .f7-icons').text()=='chevron_left') {
        location.reload();
      }
      //
      // cleanPage();
      //TODO ???si usa l'uid() aedita.monitoraggio(uid);
      aedita.visualizzazioneDati();
    },
    'aggiungi_azienda': function () {
      cleanPage();
      aedita.creaAzienda();
    },
    'bollettini/:tipo': function (param) {
      cleanPage();
      aedita.bollettini(param.tipo);
    },
    'libreria': function () {
      cleanPage();
      aedita.libreria();
    },
    'info_utili': function(){
      cleanPage();
      aedita.info_utili();
    },
    'fitosanitario': function(){  
      cleanPage();
      aedita.fitosanitario();
    },
    'fitosanitario/dpi': function(){
      cleanPage();
      aedita.dpi();
    },
    'fitosanitario/dpi/:anno': function(){
      cleanPage();
      aedita.dpi(param.anno);
    },
    'fitosanitario/dpi/:anno/:coltura': function(){
      cleanPage();
      aedita.dpi(param.anno,param.coltura);
    },
    
    'data_storic/:id_field/:fieldName/:varieta/crop/:id_crop': function (param) {
      cleanPage();
      aedita.showStoricData(param.id_field,param.id_crop,param.fieldName,param.varieta);
    },
    'data_storic/:id_field/:fieldName/crop/:id_crop/schema/:id_survey_schema': function (param) {
      cleanPage();
      aedita.getStoricTable('storicTable',param.id_survey_schema,param.id_field,'storic');
    },
    'data_entry/:id_field/:fieldName/crop/:id_crop/schema/:id_survey_schema/data/:data_monitoraggio': function (param) {
      cleanPage();
      aedita.openDataEntry(param.id_crop,param.id_field,param.fieldName,param.varieta,param.id_survey_schema,param.data_monitoraggio);
    },
    'data_entry/:id_field/:fieldName/:varieta/crop/:id_crop': function (param) {
      cleanPage();
      aedita.openDataEntry(param.id_crop,param.id_field,param.fieldName,param.varieta);
    },
    'data_entry/crop/:id_crop': function (param) {
      cleanPage();
      console.log("inserimento multiplo con crop");
      aedita.openDataEntry(param.id_crop);
    },
    'data_entry/generic': function () {
      cleanPage();
      console.log("inserimento multiplo senza crop");
      aedita.openDataEntry();
    },
    'edit_farm_center/:id_farm_center': function (param) {
      cleanPage();
      console.log(global.idFarmCenterInEditing);
      global.idFarmCenterInEditing=param.id_farm_center;
      console.log(global.idFarmCenterInEditing);
      aedita.creaAzienda('update');
    },
    'delete_survey/:id_survey/schema/:id_survey_chema/field/:id_field': function (param) {
      cleanPage();
      aedita.eliminaSurvey(param.id_survey,param.id_survey_chema,param.id_field);
    },
    'delete_survey/:id_survey/schema/:id_survey_chema/field/:id_field/storic': function (param) {
      cleanPage();
      aedita.eliminaSurvey(param.id_survey,param.id_survey_chema,param.id_field,'storic');
    }
  });

  router=partecipa.exe_routes(router);
  return router;
}

export function tools(){
  partecipa.partecipa_tools();
}

function cleanPage(){
  var html='<a href="javascript:history.back()" class="link" data-panel="left"><i class="f7-icons">chevron_left</i><span class="if-not-md">'+('Back')+'</span></a>';
  jQuery('.left').html(html);

  jQuery('#download_app').hide();

  jQuery('#footer').parent().show();
  jQuery('#footer').html('');
}

export function home_page(){
  var s=storage.get();
  var title='AgroAmbiente.Abruzzo';
  var html='';
  html+='<div class="row no-gap home_buttons">';

  html+='<div class="col-50 home_button_l">';
    html+='<a href="#bollettini/difesa" class="button button-raised button-fill button-round link external" style="margin:5px; display:flex;white-space: unset;line-height: 20px;">Bollettino Difesa integrata</a>';
  html+='</div>';

  html+='<div class="col-50 home_button_r">';
  html+='<a href="#view_data" class="button button-raised button-fill button-round link external" style="margin:5px;">Visualizza Monitoraggio</a>';
  html+='</div>';

  var next_class='home_button_l';
  if (s.user) {


    var canInsert=false;
    jQuery.each(s.user.roles,function(k,v){
      if (v=='monitor' || v=='adminmonit' || v=='adminfito') {
        canInsert=true;
      }
    });

    if (canInsert) {
      html+='<div class="col-50 '+next_class+'">';
        html+='<a href="#monitoring" class="button button-raised button-fill button-round link external" style="margin:5px;">Monitoraggio Tecnici</a>';
      html+='</div>';

      next_class='home_button_r';
    }

    var showPartecipa=false;

    jQuery.each(s.user.roles,function(k,v){
      if (v=='partecipa' || v=='libreria' || v=='info_utili' || v=='adminfito') {
        showPartecipa=true;
      }
    });

    if (showPartecipa) {
      html+='<div class="col-50 '+next_class+'">';
        html+='<a href="#partecipa" class="button button-raised button-fill button-round link external" style="margin:5px;">Monitoraggio Aziendale</a>';
      html+='</div>';
      
      next_class='home_button_l';
    }
  }
  else {
    // Tolto su richiesta loro il 30/04/2021
    // html+='<div class="col-50">';
    //   html+='<a href="#login" class="button button-raised button-fill button-round link external" style="margin:5px;">Fai il login</a>';
    // html+='</div>';
  }

  
  html+='<div class="col-50 home_button_l">';
    html+='<a href="#bollettini/agrometeorologia" class="button button-raised button-fill button-round link external" style="margin:5px; display:flex;white-space: unset;line-height: 20px;">Agrometeorologia</a>';
  html+='</div>';
  html+='<div class="col-50 home_button_r">';
  html+='<a href="#libreria" class="button button-raised button-fill button-round link external" style="margin:5px;">Approfondimenti tecnici</a>';
  html+='</div>';
  



  var next_class='home_button_l';



    html+='<div class="col-50 '+next_class+'">';
      html+='<a href="#fitosanitario" class="button button-raised button-fill button-round link external" style="margin:5px;">Servizio fitosanitario</a>';
    html+='</div>';
    next_class='home_button_r';

    html+='<div class="col-50 '+next_class+'">';
      html+='<a href="#fitosanitario/dpi" class="button button-raised button-fill button-round link external" style="margin:5px;">DPI DIFESA</a>';
    html+='</div>';


    html+='<div class="col-50 home_button_l">';
    html+='<a href="#info_utili" class="button button-raised button-fill button-round link external" style="margin:5px;">Informazioni utili</a>';
  html+='</div>';





  html+='</div>';

  var page={
    exclude_card:true,
    title: title,
    content: html
  };

  global.theme.render(page);


  // get buttons with class "button" and set the height like the width to make a square
  // jQuery('.button').each(function(){
  //   console.log(jQuery(this).width());
  //   debugger
  // });
  // debugger
  jQuery('.home_buttons a').height(jQuery(jQuery('.home_buttons a')[0]).width());


}

export function get_theme_param(theme_param){
  var sidebars=[
    {'label': 'Home page', 'icon_f7':'house', 'href':'#'},
    {'label': 'Dati', 'icon_f7':'map_pin_ellipse', 'href':'#view_data'},
  ];

  var s=storage.get();
  if (s.user) {
    theme_param.uid=s.user.uid;
    theme_param.username=s.user.username;

    var showPartecipa=false;

    jQuery.each(s.user.roles,function(k,v){
      if (v=='partecipa') {
        showPartecipa=true;
      }
    });

    if (showPartecipa) {
      sidebars.push({'label': 'Partecipa ', 'icon_f7':'doc_append', 'href':'#partecipa'});
    }
  }

  theme_param.sidebars=sidebars;
  theme_param.title='<img src="icons/abruzzo_mobile.png" height="36" width="117" />';

  // theme_param.title=global.nomeApp;

  theme_param.ptr=false; // attiva/disattiva pull to refresh
  return theme_param;
}

export function synchronize(){
  db.sync(function(){console.log("Sync");},function(e){console.log(e);},true);
}
